import * as React from "react"
import {Header, List, Segment} from "semantic-ui-react"
import {Link} from "react-router-dom"
import {ViewInvoiceForm} from "./ViewInvoiceForm"
import {WithModalStore} from "../App"

export function Admin({modalStore}: WithModalStore) {
  return (
    <Segment inverted color="olive">
      <Header as="h2">Admin</Header>
      <List>
        <List.Item>
          <ViewInvoiceForm modalStore={modalStore} />
        </List.Item>
        <List.Item>
          <Link to="/admin/common-places">Common Places</Link>
        </List.Item>
        <List.Item>
          <Link to="/admin/drivers">Drivers</Link>
        </List.Item>
        <List.Item>
          <Link to="/admin/bookings-summary">Bookings Summary</Link>
        </List.Item>
      </List>
    </Segment>
  )
}



// WEBPACK FOOTER //
// ./src/components/Admin.tsx